// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>103</span>&nbsp;&nbsp;How sweet are your words on my tongue!&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;They are sweeter than honey to my mouth.<br> </p> </div></div>";
// Exports
module.exports = code;